/**
 * Get column and row placement according to screen dimensions.
 * @param row: number
 * @param col: number
 * @param conditions: object
 * @returns {{columnStart, rowStart}}
 */
const getCellPlacement = (row, col, conditions) => {
    const { isDesktop, canCheck, totalColumns } = conditions;

    let _column = col;
    let _row = row;

    if (canCheck) {
        _column += 1;
    }

    if (!isDesktop && totalColumns && row > 1) {
        _column = 1;
        _row = totalColumns * (row - 1) + col;
    } else if (!isDesktop) {
        _column = row + (canCheck ? 1 : 0);
        _row = col;
    }

    return { columnStart: _column, rowStart: _row };
};

export default getCellPlacement;
